
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/onboarding",
      function () {
        return require("private-next-pages/resources/onboarding.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/onboarding"])
      });
    }
  